import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { withI18n } from 'react-i18next';
import styled from 'styled-components';
import { Button, ButtonGroup, Typography } from '../Common';
// @ts-ignore
import { CWBModal } from 'cwb-react';

interface IProps extends StateProps, DispatchProps, RouteComponentProps {
  t: any;
  history: any;
  match: any;
}

const InfoSheetsEnabledModal: React.FC<IProps> = ({
  t,
  history,
  match,
  setShowInfoSheetsEnabledModal
}) => {
  const handleEditSendClick = () => {
    history.push(`/templateInfoSheet/${match.params.id}`);
    setShowInfoSheetsEnabledModal(false);
  };

  return (
    <CWBModal
      isOpen={true}
      hideModal={() => setShowInfoSheetsEnabledModal(false)}
      title={(
        <Typography
          key={0}
          component="span"
          variant="h2"
        >
          {t('Info sheet enabled')}
        </Typography>
      )}
      buttons={(
        <StyledButtonGroup>
          <Button
            onClick={() => handleEditSendClick()}
          >
            {t('Edit & Send')}
          </Button>
          <Button
            variant="secondary"
            onClick={() => setShowInfoSheetsEnabledModal(false)}
          >
            {t('Not now')}
          </Button>
        </StyledButtonGroup>
      )}
    >
      <Typography
        align="left"
        color="medGrey"
      >
        {t('Info sheets have now been enabled for this session. In order to ensure that attendees receive the info sheet, please take a moment to edit and send the info sheet.')}
      </Typography>
    </CWBModal>
  );
};

const StyledButtonGroup = styled(ButtonGroup)`
  margin: ${p => p.theme.spacing(0, 'auto', 1, '-0.25rem')};
`;

interface StateProps {}

const mapStateToProps = (state: any) => ({
});

interface DispatchProps {
  setShowInfoSheetsEnabledModal: (show: boolean) => any;
}

const mapDispatchToProps = (dispatch: any) => ({
  setShowInfoSheetsEnabledModal: dispatch.kiosk.setShowInfoSheetsEnabledModal
});

export default withI18n()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoSheetsEnabledModal)));
